























import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { ICustomer } from '@/lib/interfaces';
import { getAllCustomers } from '@/services/api.service';

@Component
export default class Customers extends Vue {
  public customers: ICustomer[] = [];

  private async beforeRouteEnter(to: Route, from: Route, next: (vm?: any) => void) {
    const customers: ICustomer[] = await getAllCustomers();
    next((vm: Customers) => {
      vm.customers = customers;
    });
  }
}
